import baseApi from 'shared/api/baseApi';

// Minimal subset of the backend `CatalogTemplate` — only the fields the front needs.
export interface TemplateBodyExample {
  body_text?: string[][];
}
export interface TemplateButton {
  type: string; // 'QUICK_REPLY' | 'URL' | 'PHONE_NUMBER' | 'COPY_CODE'
  text: string;
  url?: string;
}
export interface TemplateComponent {
  type: string; // 'BODY' | 'HEADER' | 'FOOTER' | 'BUTTONS'
  text?: string;
  example?: TemplateBodyExample;
  buttons?: TemplateButton[];
}
export interface CatalogTemplate {
  name: string;
  language: string;
  status: string | null;
  provider: { components?: TemplateComponent[] } | null;
}

interface TemplateCatalogResponse {
  data: CatalogTemplate[];
  providerUnavailable: boolean;
}

const templatesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTemplateCatalog: build.query<TemplateCatalogResponse, { projectId: number }>({
      query: ({ projectId }) => ({ url: `/templates/catalog?projectId=${projectId}`, method: 'GET' as const }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetTemplateCatalogQuery } = templatesApi;
